module.exports = __webpack_public_path__ + "img/PG1_2-7-259x195.9a10c792.png";